import { colors } from '@ardoq/design-tokens';
import styled, { css } from 'styled-components';

export const BaseContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  background: ${colors.surfaceStatusNeutral};
`;

export const Header = styled.div`
  display: flex;
  align-items: stretch;
  flex: 0 0 58px;
  border-bottom: 1px solid ${colors.borderAction};
  z-index: 10;
  background: ${colors.surfaceDefault};
`;

export const NoPrintHeader = styled(Header)`
  @media print {
    display: none !important;
  }
`;

export const MainBodyWrapper = styled.div<{ $hasHeader?: boolean }>`
  height: 100%;
  width: 100%;
  flex: 1;
  flex: 0 0 auto;
  display: flex;
  flex-direction: row;
  ${props =>
    props.$hasHeader &&
    css`
      padding-bottom: 58px;
    `}
`;

export const HeaderContent = styled.div<{ $fullWidth?: boolean }>`
  padding: 0 32px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: space-between;
  max-width: ${props => (props.$fullWidth ? 'auto' : '1500px')};
`;

export const HeaderTitle = styled.div`
  font-size: 20px;
  font-weight: 400;
`;

export const HeaderButtonsContainer = styled.div`
  display: flex;
  button {
    margin-left: 8px;
  }
`;

export const BodyWrapper = styled.div`
  background: ${colors.surfaceDefault};
  flex: 1 1 100%;
  overflow: auto;
  height: 100%;
`;

export const BodyContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 32px;
`;

export const SidebarContainer = styled.div`
  display: flex;
  flex: 0 0 270px;
  border-right: 1px solid ${colors.borderAction};
  justify-content: stretch;
  flex-direction: column;
  background: ${colors.surfaceStatusNeutral};
  overflow: auto;
`;

export const NoPrintSidebarContainer = styled(SidebarContainer)`
  @media print {
    display: none !important;
  }
`;
